import React, { useState } from 'react'
import { Card, CardContent, Box, Tab } from '@mui/material'
import { TabList, TabPanel } from '@mui/lab'
import SynchronizationConfigurationSection from '../ConfigurationSections/SynchronizationConfigurationSection'
import DeviceConfigurationSection from '../ConfigurationSections/DeviceConfigurationSection'
import TabContext from '@mui/lab/TabContext'
import IdsConfigurationSection from '../ConfigurationSections/IdsConfigurationSection'
import { FormTabProps } from '../../types/FormTab.types'

const MachineTab = ({ formState, handleChangeByShadow }: FormTabProps) => {
    const [currentSubTab, setCurrentSubTab] = useState('1')

    const handleTabChange = (event: React.SyntheticEvent, newValue: string) => {
        setCurrentSubTab(newValue)
    }

    return (
        <Box className="sub-card-container" sx={{ height: '100%' }}>
            <TabContext value={currentSubTab}>
                <TabList onChange={handleTabChange} orientation="vertical" sx={{ width: '174px' }}>
                    <Tab label="Urządzenie" value="1" className="sub-card-tab" sx={{ color: '#858585' }} />
                    <Tab label="IDS" value="2" className="sub-card-tab" sx={{ color: '#858585' }} />
                    <Tab label="Synchronizacja" value="3" className="sub-card-tab" sx={{ color: '#858585' }} />
                    <Tab label="VSD" value="4" className="sub-card-tab" sx={{ color: '#858585' }} disabled />
                </TabList>
                <Card sx={{ width: '77%', p: 0 }} variant="outlined" className="card-configuration">
                    <CardContent sx={{ p: 2 }} className="card-configuration">
                        <TabPanel value="1" sx={{ p: 0 }} className="configuration-option">
                            <DeviceConfigurationSection
                                formState={formState}
                                handleChangeByShadow={handleChangeByShadow}
                            ></DeviceConfigurationSection>
                        </TabPanel>

                        <TabPanel value="2" sx={{ p: 0 }} className="configuration-option">
                            <IdsConfigurationSection
                                formState={formState}
                                handleChangeByShadow={handleChangeByShadow}
                            ></IdsConfigurationSection>
                        </TabPanel>

                        <TabPanel value="3" sx={{ p: 0 }} className="configuration-option">
                            <SynchronizationConfigurationSection
                                formState={formState}
                                handleChangeByShadow={handleChangeByShadow}
                            ></SynchronizationConfigurationSection>
                        </TabPanel>

                        <TabPanel value="4" sx={{ p: 0 }} className="configuration-option">VSD</TabPanel>
                    </CardContent>
                </Card>
            </TabContext>
        </Box>
    )
}

export default MachineTab
